import consumer from "../consumer"

function isPositionBottom() {
  let scroll_position = $('#chat_history').get(0).scrollHeight - $('#chat_history').get(0).offsetHeight - $('#chat_history').scrollTop();
  // 100以上はなれていなければ最下部する
  return scroll_position < 100
}
function scrollToBottom() {
  // let scroll_position = $('#chat_history').get(0).scrollHeight - $('#chat_history').get(0).offsetHeight - $('#chat_history').scrollTop();
  // 100以上はなれていなければ最下部する
  // if (scroll_position < 100) {
  // $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight)
  // }
  if (isPositionBottom()) {
    $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight)
  }
}
window.onload = function () {
  const chat_room_key = room_key
  const group_id = window.location.href.split('/')[6]

  consumer.subscriptions.create({ channel: "AccuracyTestRoomChannel", chat_room_key: chat_room_key, group_id: group_id }, {
    connected() {
      // Called when the subscription is ready for use on the server
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },
    received(data) {
      let json_data = {}
      if (data['finish'] !== "true") {
        json_data = JSON.parse(data['data'])
        $(`#current_bot_message_${json_data.chat_key}`).append(json_data.message.replace(/\n/g, '<br>'))
        // これが0にちかければ最下部にいる
        scrollToBottom()
        if (json_data.end_flg == true) {
          if (json_data.documents.length > 0) {
            let queryString = window.location.search
            let params = new URLSearchParams(queryString)
            let chat_room_id = params.get('chat_room_id')
            let url = window.location.href.substring(0, window.location.href.indexOf('?'))
            res = jQuery.ajax({
              url: url + "/" + chat_room_id + "/bot_documents",
              type: 'post',
              data: { documents: json_data['documents'], chat_room_history_id: json_data['chat_key'] },
              dataType: 'json',
              success: function (data) {
                let isBottom = isPositionBottom()
                // 資料の場合はどかっとHTMLが入るので、bottomかのしきい値が超えてしまうので先にbottomにあるかチェックする
                $(`#current_bot_documents_link_${data.chat_room_history_id}`).html(data.html)
                // scrollToBottom()
                if (isBottom) {
                  $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight)
                }
                // restart_chat()
              }
            })
          } else {
            // restart_chat()
          }
        }
      } else {
        json_data = data['data']
        const current_chat_room_bot_history_id = data['current_chat_room_bot_history_id']
        $(`#current_bot_message_${json_data['chat_key']
          }`).append(json_data['answer'].replace(/\n/g, '<br>'))
        let bot_message_lengths = []
        $('.bot_message').each( function (){
          const length = $(this).text().length
          bot_message_lengths.push(length)
        });
        if (!bot_message_lengths.includes(0)) {
          add_sample_word(current_chat_room_bot_history_id, json_data['chat_key'])
          restart_chat()
        }
      }
    }
  });
  function restart_chat() {
    $(".current_bot_loading").removeClass('d-inline')
    $(".current_bot_loading").addClass('d-none')
    $(".js_chat_index_accuracy_test").prop('disabled', false)
    $(".js_chat_index_accuracy_test").removeClass('btn-secondary')
    $(".js_chat_index_accuracy_test").addClass('btn-primary')
    $(".js_chat_index_accuracy_test_create_q").prop('disabled', false)
    $(".js_chat_index_accuracy_test_create_q").removeClass('btn-secondary')
    $(".js_chat_index_accuracy_test_create_q").addClass('btn-outline-secondary')
    scrollToBottom();
  }

  function add_sample_word(current_chat_room_bot_history_id, add_template_chat_room_history_id) {
    let queryString = window.location.search
    let params = new URLSearchParams(queryString)
    let accuracy_test_room_id = params.get('accuracy_test_room_id')
    let url = window.location.href.substring(0, window.location.href.indexOf('?'))
    res = jQuery.ajax({
      url: url + "/" + accuracy_test_room_id + "/sample_word_text",
      type: 'get',
      data: { current_chat_room_bot_history_id: current_chat_room_bot_history_id, chat_room_history_id: add_template_chat_room_history_id },
      dataType: 'json',
      success: function (data) {
        $(`#current_bot_message_${data.current_chat_room_bot_history_id}`).append(data.html)
        $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight);
        add_prompt(current_chat_room_bot_history_id, add_template_chat_room_history_id)
      }
    })
  }
  function add_prompt(current_chat_room_bot_history_id, add_template_chat_room_history_id) {
    let queryString = window.location.search
    let params = new URLSearchParams(queryString)
    let accuracy_test_room_id = params.get('accuracy_test_room_id')
    let url = window.location.href.substring(0, window.location.href.indexOf('?'))
    res = jQuery.ajax({
      url: url + "/" + accuracy_test_room_id + "/prompt_text",
      type: 'get',
      data: { current_chat_room_bot_history_id: current_chat_room_bot_history_id, chat_room_history_id: add_template_chat_room_history_id },
      dataType: 'json',
      success: function (data) {
        $(`#current_bot_message_${data.current_chat_room_bot_history_id}`).append(data.html)
        $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight);
      }
    })
  }
}
